import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getPendingAggregatorLoans = async (queryParams) => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.PENDING_AGGREGATOR_LOANS}?${new URLSearchParams(
      queryParams
    ).toString()}`
  );

  return data;
};

export default function usePendingAggregatorLoans(params) {
  return useQuery(
    [params, "getPendingAggregatorLoans"],
    getPendingAggregatorLoans,
    {
      refetchOnWindowFocus: false,
    }
  );
}
